import { Search } from "react-feather";
import { Button, CardBody, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import PaginationComponent from "Component/Learning/Common/Pagination";
import { handleBackPagination, handleClickPagination, handleNextPagination } from "Component/Learning/Users/UsersUtils";
import { setFilters } from "Features/Learning/Users/userSlice";
import { fetchUsers } from "Features/Learning/Users/Utils/UserUtils";
import AsyncSelectCommon from "Component/Learning/Common/SelectOption/AsyncSelect";
import { fetchMemberships } from "Features/Learning/Memberships/Utils/MembershipUtils";
import Swal from "sweetalert2";
import {
  setField as setFieldAttachDetach,
  resetState as resetAttachDetach,
} from "Features/Classes/Class/attachDetachUserToClassSlice";
import {
  attachDetachUserToClass,
  fetchClasses,
  fetchDetailMemberClass
} from "Features/Classes/Class/Utils/ClassUtils";
import { handleGetDetailClass } from "Component/Classes/Class/ClassUtils";
import { setDetail } from "Features/Classes/Class/ClassSlice";

const ModalAddUsers = ({ classId, handleOpenUsers, openUsers, selectedValue, setSelectedValue }) => {
  const [dataUsers, setDataUsers] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [initialSelectedSnapshot, setInitialSelectedSnapshot] = useState([]);
  const [refatch, setRefatch] = useState(false);
  const [search, setSearch] = useState('');
  const filters = useSelector((state) => state.User.filters);
  const filterClass = useSelector((state) => state.Class.filters);
  const isLoading = useSelector(state => state.attachUsersMembership.isLoading)
  const pagination = useSelector((state) => state.User.data.pagination);
  const data = useSelector((state) => state.attachDetachUserToClass);
  const filterMembership = useSelector((state) => state.Membership.filters);
  const dataMember = useSelector((state) => state.detailMemberClass.data.data);
  const [selectedValueMembership, setSelectedValueMembership] = useState(null);
  const dispatch = useDispatch();
  const [isSelectAll, setIsSelectAll] = useState(false);

  useEffect(() => {
    if (data?.membershipId) {
      dispatch(fetchUsers({
        ...filters,
        'sort': 'name',
        'include': '',
        'filter[membership.id]': data.membershipId,
      }))
        .then((response) => {
          setDataUsers(response?.payload?.data ?? [])
        })
        .catch((error) => {
          console.error('Error fetching options:', error);
        });
    }
  }, [refatch, data?.membershipId, filters, dispatch])

  useEffect(() => {
    dataUsers.every(item => selectedIds.includes(item.id)) ? setIsSelectAll(true) : setIsSelectAll(false)
  }, [selectedIds, dataUsers])

  useEffect(() => {
    if (selectedValue?.length > 0) {
      setSelectedIds(selectedValue.map(item => item.id));
    }
  }, [selectedValue])

  const promiseOptionMemberships = (inputValue, callback) => {
    dispatch(
      fetchMemberships({
        ...filterMembership,
        "filter[title]": inputValue,
        sort: "-id",
        page: 1,
        include: "",
      })
    )
      .then((response) => {
        const options = response.payload.data.map((item) => ({
          value: item.id,
          label: item.title,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        callback([]);
      });
  };

  const handleSelectChangeMembership = (selectedOption) => {
    // validation membership already exist
    if (selectedOption === null) {
      setDataUsers([]);
      dispatch(
        setFieldAttachDetach({
          field: "membershipId",
          value: ''
        })
      );
      setSelectedValueMembership(null);
      setSearch('');
      return
    }

    if (
      selectedOption &&
      dataMember.some((item) => item.id === selectedOption.value)
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Membership ini sudah terdaftar pada kelas ini!",
      });
    } else {
      setSelectedValueMembership(selectedOption);
      dispatch(setFieldAttachDetach({ field: "userId", value: [] }));
      dispatch(
        setFieldAttachDetach({ field: "class_id", value: parseInt(classId) })
      );
      dispatch(
        setFieldAttachDetach({
          field: "membershipId",
          value: selectedOption === null ? "" : selectedOption.value,
        })
      );
      // get user by membership & set to state
      dispatch(
        fetchUsers({
          // ...filterUser,
          // 'filter[name]': inputValue,
          sort: "name",
          page: 1,
          include: "",
          "filter[membership.id]":
            selectedOption === null ? "" : selectedOption.value,
        })
      )
        .catch((error) => {
          console.error("Error fetching options:", error);
        });
    }
  };

  const handleClickSearch = () => setRefatch(!refatch)

  const updateSearchParams = useCallback(() => {
    // Pastikan value yang disimpan ke redux filter selalu string
    const safeNameStart = Array.isArray(search)
      ? search[0] || ''
      : search || '';

    dispatch(
      setFilters({
        ...filters,
        "filter[name_start]": safeNameStart,
        "page": 1
      })
    );
  }, [search, filters, dispatch]);

  useEffect(() => {
    const delay = setTimeout(updateSearchParams, 500);

    return () => clearTimeout(delay);
  }, [search]);

  const handleSelectAll = () => {
    if (isSelectAll) {
      const newSelectedValue = selectedValue?.filter((value) => !dataUsers.some((item) => item.id === value.id));
      const newSelectedIds = selectedIds.filter((id) => !dataUsers.some((item) => item.id === id));
      setSelectedValue(newSelectedValue);
      setSelectedIds(newSelectedIds);
    } else {
      const newSelectedValue = dataUsers.filter((item) => !selectedValue?.some((value) => value.id === item.id));
      const newSelectedIds = dataUsers.map((item) => item.id).filter((id) => !selectedIds.includes(id));
      setSelectedValue([...selectedValue, ...newSelectedValue]);
      setSelectedIds([...selectedIds, ...newSelectedIds]);
    }
  };

  const handleCheckboxChange = (item) => {
    if (selectedIds.includes(item.id)) {
      const newSelectedValue = selectedValue?.filter((value) => value.id !== item.id);
      const newSelectedIds = selectedIds.filter((id) => id !== item.id);
      setSelectedValue(newSelectedValue);
      setSelectedIds(newSelectedIds);
    } else {
      setSelectedValue([...selectedValue, item]);
      setSelectedIds([...selectedIds, item.id]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const newSelectedValue = selectedValue?.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.id === value.id
        ))
      );

      let errorMessage = "";
      if (!data.membershipId) {
        errorMessage = "Silahkan pilih membership terlebih dahulu";
      } else if (data.membershipId && !data.userId) {
        errorMessage = "Silahkan pilih user yang akan ditambahkan";
      }
      // validation
      if (!data.membershipId || (data.membershipId && !data.userId)) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      } else {
        const { class_id, membershipId } = data
        const response = await dispatch(attachDetachUserToClass({ class_id, membershipId, userId: newSelectedValue.map((item) => item.id) }));
        if (response.payload === true) {
          handleOpenUsers(false)
          Swal.fire({
            title: "Berhasil!",
            text: "User berhasil ditambahkan ke kelas",
            icon: "success",
            confirmButtonText: "Oke",
          });
          setDataUsers([]);
          dispatch(
            setFieldAttachDetach({
              field: "membershipId",
              value: ''
            })
          );
          setSelectedValueMembership(null);
          // clear selection and snapshot after successful save
          setSelectedValue([]);
          setSelectedIds([]);
          setInitialSelectedSnapshot([]);
          setSearch('');
          dispatch(resetAttachDetach());
          dispatch(fetchDetailMemberClass(classId));
          const newFilters = {
            ...filterClass,
            "filter[id]": classId,
            page: 1,
          };
          dispatch(fetchClasses(newFilters))
            .then((response) => {
              // Kode yang akan dijalankan setelah fetch sukses
              handleGetDetailClass(
                dispatch,
                response.payload.data[0],
                setDetail
              );
              // Kode lain yang perlu dijalankan setelah fetch sukses
            })
            .catch((error) => {
              // Tangani error jika fetch gagal
              console.error("Error during fetchClasses:", error);
            });
        } else {
          Swal.fire({
            title: "Gagal!",
            text: "User gagal ditambahkan ke kelas",
            icon: "error",
            confirmButtonText: "Oke",
          });
        }
      }
    } catch (error) {
      console.error("Error:", error);
      // Modal tidak akan ditutup jika terjadi kesalahan
    }
  }

  // handle cancel: confirm only when selection changed vs snapshot; restore snapshot on cancel
  const handleRequestCancel = async () => {
    const initialIds = (initialSelectedSnapshot || []).map(i => i.id).slice().sort().join(',');
    const currentIds = (selectedIds || []).slice().sort().join(',');

    const changed = initialIds !== currentIds;
    if (changed) {
      const result = await Swal.fire({
        title: 'Batalkan perubahan?',
        text: 'Perubahan yang belum disimpan akan dibatalkan.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      });
      if (!result.isConfirmed) return;
    }

    // restore snapshot and close modal
    const original = initialSelectedSnapshot || [];
    setSelectedValue(original);
    setSelectedIds(original.map(i => i.id));
    setDataUsers([]);
    dispatch(
      setFieldAttachDetach({
        field: "membershipId",
        value: ''
      })
    );
    setSelectedValueMembership(null);
    setSearch('');
    setInitialSelectedSnapshot([]);
    handleOpenUsers();
  }

  return (
    <Modal isOpen={openUsers} size="lg">
      <ModalHeader onClick={handleOpenUsers}>
        Tambahkan Peserta ke Kelas
      </ModalHeader>
      <ModalBody>
        <ul>
          {selectedValue?.length > 0 &&
            selectedValue?.map((item, index) => (
              <li key={`item-${index}`}>
                {item.id} - {item.name}
              </li>
            ))}
        </ul>
        <div className="mt-3">
          <AsyncSelectCommon
            label={"Membership"}
            placeholder={"Silahkan pilih membership..."}
            isMulti={false}
            promiseOptions={promiseOptionMemberships}
            handleSelectChange={(selectedOption) =>
              handleSelectChangeMembership(selectedOption)
            }
            selectedValue={selectedValueMembership}
            // disable ketika user sudah memilih minimal 1 peserta di daftar (selectedValue)
            isDisabled={Array.isArray(selectedValue) && selectedValue.length > 0}
          />
        </div>
        <div className="faq-form mt-3">
          <Input
            className="form-control"
            type="text"
            placeholder="Search.."
            value={search}
            onKeyUp={(e) => (e.key === "Enter" ? handleClickSearch(e) : null)}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Search className="search-icon" />
        </div>
        <Table className="table-responsive table-bordered my-3">
          <thead className="table-light">
            <tr>
              <th scope="col">{"#"}</th>
              <th scope="col">{"ID"}</th>
              <th scope="col">Nama Peserta</th>
              <th scope="col" className="text-center" colSpan="2">
                <Input
                  className="checkbox_animated"
                  id={`selectAll`}
                  type="checkbox"
                  checked={selectedIds.length > 0 && isSelectAll}
                  onChange={handleSelectAll}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {dataUsers && dataUsers.length > 0 ? (
              dataUsers.map((item, index) => (
                <tr key={`item-${index}`}>
                  <th>{pagination?.from + index}</th>
                  <th>{item.id}</th>
                  <td>{item.name}</td>

                  <td className="text-center">
                    <Input
                      className="checkbox_animated"
                      id={`detach-${item.id}`}
                      type="checkbox"
                      checked={selectedIds.includes(item.id)}
                      onChange={() => handleCheckboxChange(item)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  Tidak ada data peserta
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <CardBody>
          {(isLoading === false && pagination && pagination.last_page > 1) && (
            <PaginationComponent
              pagination={pagination}
              handleBackPagination={() =>
                handleBackPagination(
                  pagination,
                  filters,
                  dispatch,
                  setFilters,
                  setRefatch
                )
              }
              handleClickPagination={(page) =>
                handleClickPagination(
                  page,
                  filters,
                  dispatch,
                  setFilters,
                  setRefatch
                )
              }
              handleNextPagination={() =>
                handleNextPagination(
                  pagination,
                  filters,
                  dispatch,
                  setFilters,
                  setRefatch
                )
              }
            />
          )}
        </CardBody>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleRequestCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit} disabled={isLoading}>
          Save
        </Button>{" "}
      </ModalFooter>
    </Modal>
  )
}

export default ModalAddUsers